module.exports = "/lucky-balls/img/bonus_green/number_picked.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/number_picked.png
// module id = 942
// module chunks = 0